import { createContext } from "react"

const UserDataContext = createContext({

})
export default UserDataContext